(() => {
  if (customElements.get('product-card')) {
    return;
  }

  class ProductCard extends HTMLElement {
    constructor() {
      super();

      this.variantsSelect = this.querySelector('[data-product-select]');
      this.swatches = this.querySelectorAll('[data-swatches] input');
      this.media = this.querySelector('[data-product-media]');
      this.form = this.querySelector('form');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.quickviewTemplate = document.querySelector('#product-quickview');
      this.productTitle = this.dataset.productTitle;
      this.productId = this.dataset.productId;

      this.hoverVariantBtns = this.querySelectorAll('.product-card__hover-variant');
      this.hoverCta = this.querySelector('[data-hover-cta]');
      this.hoverOverlay = this.querySelector('.product-card__hover-overlay');

      const primaryImg = this.media && this.media.querySelector('[data-primary-image]');
      this.defaultImageSrc = primaryImg ? primaryImg.src : null;
      this.defaultImageSrcset = primaryImg ? primaryImg.srcset : null;
      this.mobileVariantSelect = this.querySelector('[data-mobile-variant-select]');
      this.mobileShopNow = this.querySelector('[data-mobile-shop-now]');
      this.mobileNotifyMe = this.querySelector('[data-mobile-notify-me]');

      this.swatches.forEach((swatch) => {
        swatch.addEventListener('change', this.onSwatchChange.bind(this));
      })

      this.hoverVariantBtns.forEach((btn) => {
        btn.addEventListener('click', this.onHoverVariantClick.bind(this));
      });

      // Set initial CTA state based on first visible variant
      if (this.hoverVariantBtns.length > 0) {
        this.updateHoverCta(this.hoverVariantBtns[0].dataset.variantAvailable === 'true');
      }

      this.addEventListener('mouseleave', () => {
        if (this.hoverOverlay) this.hoverOverlay.classList.remove('has-variant-selected');

        const primaryImg = this.media && this.media.querySelector('[data-primary-image]');
        if (primaryImg && this.defaultImageSrc) {
          primaryImg.src = this.defaultImageSrc;
          primaryImg.srcset = this.defaultImageSrcset;
        }

        const secondaryImg = this.media && this.media.querySelector('[data-secondary-image]');
        if (secondaryImg) secondaryImg.style.display = '';
      });

      if (this.mobileVariantSelect) {
        this.mobileVariantSelect.addEventListener('change', this.onMobileVariantChange.bind(this));

        const firstAvailable = Array.from(this.mobileVariantSelect.options).find(
          (opt) => opt.dataset.variantAvailable === 'true'
        );
        if (firstAvailable) {
          firstAvailable.selected = true;
          if (this.variantsSelect) this.variantsSelect.value = firstAvailable.value;
        }

        const initialOption = this.mobileVariantSelect.selectedOptions[0];
        if (initialOption) {
          const isAvailable = initialOption.dataset.variantAvailable === 'true';
          if (this.mobileShopNow) this.mobileShopNow.classList.toggle('hidden', !isAvailable);
          if (this.mobileNotifyMe) this.mobileNotifyMe.classList.toggle('hidden', isAvailable);
        }
      }

      if (this.variantsSelect) {
        this.variantsSelect.addEventListener('change', this.onVariantChange.bind(this));
      }

      this.form && this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    onHoverVariantClick(event) {
      const btn = event.currentTarget;
      const variantId = btn.dataset.variantId;
      const isAvailable = btn.dataset.variantAvailable === 'true';

      this.hoverVariantBtns.forEach((v) => v.classList.remove('is-selected'));
      btn.classList.add('is-selected');

      if (this.variantsSelect) {
        this._skipImageUpdate = true;
        this.variantsSelect.value = variantId;
        this.variantsSelect.dispatchEvent(new Event('change'));
        this._skipImageUpdate = false;
      }

      this.updateHoverCta(isAvailable);
      if (this.hoverOverlay) this.hoverOverlay.classList.add('has-variant-selected');
    }

    onMobileVariantChange(event) {
      const selectedOption = event.target.selectedOptions[0];
      const variantId = selectedOption.value;
      const isAvailable = selectedOption.dataset.variantAvailable === 'true';
      const variantUrl = selectedOption.dataset.variantUrl;

      if (this.variantsSelect) {
        this.variantsSelect.value = variantId;
        this.variantsSelect.dispatchEvent(new Event('change'));
      }

      if (this.mobileShopNow) {
        this.mobileShopNow.classList.toggle('hidden', !isAvailable);
      }
      if (this.mobileNotifyMe) {
        this.mobileNotifyMe.classList.toggle('hidden', isAvailable);
        if (variantUrl) this.mobileNotifyMe.href = variantUrl;
      }
    }

    updateHoverCta(isAvailable) {
      if (!this.hoverCta) return;

      if (isAvailable) {
        this.hoverCta.textContent = 'Add to Cart';
        this.hoverCta.disabled = false;
        this.hoverCta.classList.remove('is-unavailable');
      } else {
        this.hoverCta.textContent = 'Out of Stock';
        this.hoverCta.disabled = true;
        this.hoverCta.classList.add('is-unavailable');
      }
    }

    onSwatchChange(event) {
      const optionSelector = `option[data-option${
        event.target.dataset.optionPosition
      }="${event.target.value}"]`;

      this.variantsSelect.value = this.variantsSelect.querySelector(optionSelector).value;
      this.variantsSelect.dispatchEvent(new Event('change'));
    }

    onVariantChange(event) {
      const selectedOption = event.target.selectedOptions[0];

      this.querySelectorAll('[data-product-link]').forEach((link) => {
        link.setAttribute('href', `${this.dataset.url}${selectedOption.value}`)
      })

      if (this._skipImageUpdate) return;

      if (!selectedOption.dataset.imageSrc || !selectedOption.dataset.imageSrcset) {
        return;
      }

      this.media.classList.remove('has-hover');

      if(this.media.querySelector('[data-secondary-image]')) {
        this.media.querySelector('[data-secondary-image]').style.display = 'none';
      }
      if(this.media.querySelector('[attr="data-secondary-image"]')) {
        this.media.querySelector('[attr="data-secondary-image"]').style.display = 'none';
      }
      if(this.media.querySelector('[data-primary-image]')) {
        this.media.querySelector('[data-primary-image]').src = selectedOption.dataset.imageSrc;
        this.media.querySelector('[data-primary-image]').srcset = selectedOption.dataset.imageSrcset;
      }
      if(this.media.querySelector('[attr="data-primary-image"]')) {
        this.media.querySelector('[attr="data-primary-image"]').src = selectedOption.dataset.imageSrc;
        this.media.querySelector('[attr="data-primary-image"]').srcset = selectedOption.dataset.imageSrcset;
      }

    }

    onSubmit(event) {
      event.preventDefault();

      const submitter = event.submitter || event.target.querySelector('[type="submit"]');
      const dispatchSubmit = submitter.hasAttribute('data-url');

      if (!dispatchSubmit) {
        this.addItemToCart(submitter);

        return;
      }

      if (window.modals && window.modals[`Product-Quickview-${this.productId}`]) {
        const quickview = window.modals[`Product-Quickview-${this.productId}`];

        this.attachQuickview(submitter, quickview);

        return;
      }

      fetch(`${submitter.dataset.url}&variant=${this.variantsSelect.value}`)
        .then((response) => response.text())
        .then((responseText) => {
          this.buildQuickView(submitter, responseText);
        })
    }

    buildQuickView(submitter, responseText) {
      const productDetails = new DOMParser()
        .parseFromString(responseText, 'text/html')
        .querySelector('[data-product-details]');
      const productFeaturedMedia = Array.from(
        new DOMParser()
        .parseFromString(responseText, 'text/html')
        .querySelectorAll('[data-product-media]')
      ).filter((media) => media.children[0].tagName.toLowerCase() !== 'modal-opener' && media.children[0].tagName.toLowerCase() !== 'deferred-media');
      const quickview = this.quickviewTemplate.content.cloneNode(true).querySelector('.product-quickview');

      quickview.id = `${quickview.id}${this.productId}`;
      quickview.querySelectorAll('[data-modal-close]').forEach((element) => {
        element.id = `${element.id}${this.productId}`;
      });

      if (quickview.querySelector('[role="dialog"]').ariaLabel) {
        quickview.querySelector('[role="dialog"]').ariaLabel =
          quickview.querySelector('[role="dialog"]').ariaLabel.replace('{{ product_title }}', this.productTitle);
      }

      productFeaturedMedia.forEach((media, index) => {
        media.children[0].setAttribute('data-product-quickview-media', '');

        if (index === 0) {
          return;
        }

        media.children[0].style.display = 'none';
      });
      quickview.querySelector('[data-media-wrapper]').innerHTML = Array.from(productFeaturedMedia).map((media) => media.innerHTML).join('');
      quickview.querySelector('[data-details-wrapper]').innerHTML = productDetails.innerHTML;

      this.attachQuickview(submitter, quickview);
    }

    attachQuickview(submitter, quickview) {
      document.body.append(quickview);
      setTimeout(() => {
        quickview.show(submitter);
      }, 1);
    }

    addItemToCart(submitter) {
      if (submitter) {
        submitter.classList.add('is-loading');
        submitter.disabled = true;
      }

      const resetSubmitter = () => {
        if (submitter) {
          submitter.classList.remove('is-loading');
          submitter.disabled = false;
        }
      };

      if (!this.cartDrawer) {
        this.form && this.form.submit();

        return;
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartDrawer.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      this.cartDrawer.setActiveElement(document.activeElement);

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            window.console.error(response.status);
            resetSubmitter();

            return;
          }

          this.cartDrawer.handleAddedItem(response);
          resetSubmitter();
        })
        .catch((error) => {
          window.console.error(error);
          resetSubmitter();
        });
    }
  }

  customElements.define('product-card', ProductCard);
})();
